'use strict';

var index$1 = require('../../_virtual/index.js_commonjs-module12.js');
var index = require('./node_modules/has-symbols/index.js');

var toStr = Object.prototype.toString;
var hasSymbols = index();

if (hasSymbols) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isRealSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') {
			return false;
		}
		return symStringRegex.test(symToStr.call(value));
	};

	index$1.isSymbol.exports = function isSymbol(value) {
		if (typeof value === 'symbol') {
			return true;
		}
		if (toStr.call(value) !== '[object Symbol]') {
			return false;
		}
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {

	index$1.isSymbol.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return false ;
	};
}
